import { Remove, Straight } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceSuggestionType } from '@retail/products/types';
import { getPriceSuggestionType } from '@retail/products/utils';

interface Props {
  priceType: PriceSuggestionType;
  priority: number;
  totalPrioritySuggestions: number;
  checkPriceType: (priceType: PriceSuggestionType) => void;
  handleReprioritizedPriceSuggestions: (priceTypeIndex: number, prioritize: 'UP' | 'DOWN') => void;
  getPriceTypeValue: (priceType: PriceSuggestionType) => string;
}

export function PrioritizedPriceType({
  priceType,
  priority,
  totalPrioritySuggestions,
  checkPriceType,
  handleReprioritizedPriceSuggestions,
  getPriceTypeValue,
}: Props) {
  const t = usePriceSuggestionTFunction();

  return (
    <Stack direction="row" flexGrow={1} alignItems="center" gap={2} px={4}>
      <Typography variant="subtitle1">{priority}.</Typography>
      <Stack direction="row" alignItems="center" gap={4} py={1}>
        <Typography variant="body1">{getPriceSuggestionType(t, priceType)}</Typography>
        <Typography variant="body2">{getPriceTypeValue(priceType)}</Typography>
      </Stack>
      <Stack flexDirection="row" flexGrow={1} justifyContent="flex-end">
        <IconButton
          disabled={priority === 1}
          sx={{ p: 0 }}
          onClick={() => handleReprioritizedPriceSuggestions(priority - 1, 'UP')}
        >
          <Straight fontSize="small" />
        </IconButton>

        <IconButton
          disabled={priority === totalPrioritySuggestions}
          sx={{ p: 0 }}
          onClick={() => handleReprioritizedPriceSuggestions(priority - 1, 'DOWN')}
        >
          <Straight sx={{ rotate: '180deg' }} fontSize="small" />
        </IconButton>

        <IconButton sx={{ p: 0 }} onClick={() => checkPriceType(priceType)}>
          <Remove fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
}
